export default __webpack_public_path__ + "static/media/trailer-details.99f2e30f.png";